import { translate } from "@utils";

import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

export const PolicyFormLevelsAddToList = ({ viewOnly = false, activePolicy, setActivePolicy, levelType, levelOptions }) => {
	return (
		<div>
			<Autocomplete
				renderInput={(params) => <TextField {...params} label={translate(levelType)} />}
				disablePortal
				disabled={viewOnly}
				options={levelOptions.map((level) => `${level.name} (ID-${level.id})`)}
				value={activePolicy.levels[levelType].map((level) => `${level.name} (ID-${level.id})`)}
				noOptionsText={!levelOptions.length ? translate("loading") : translate("noOptionsFound")}
				disableCloseOnSelect={true}
				onChange={(e, newLevels) => {
					setActivePolicy((prevState) => {
						return {
							...prevState,
							levels: {
								...prevState.levels,
								[levelType]: levelOptions.filter((level) => newLevels.includes(`${level.name} (ID-${level.id})`)),
							},
						};
					});
				}}
				limitTags={2}
				multiple
			/>
		</div>
	);
};
